import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import NoFreeBoxModal from '../../../../../../Common/NoFreeBoxModal';
import { getCabId32Str } from '../../../../../../../../lib/utils/utils';
import { updateFoodifoxData } from '../../../../../../../../lib/axios/FoodifoxDataAPI';
import { addSystemLog } from '../../../../../../../../lib/SystemLogUtils';
import SmallCabNoFreeBoxModal from '../../SmallCabNoFreeBoxModal';
import LargeCabNoFreeBoxModal from '../../LargeCabNoFreeBoxModal';
import { Box } from '../../../../../../../../lib/types';
import SquadBoldText from '../../../../../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../../../../../components/Text/PingFangSemiBoldText';
import Button from '../../../../../../../../components/Button';

const OpenBtn: FC<Props> = ({
  isEnglish,
  setShowLoading,
  platform,
  driverId,
  smallCabId,
  largeCabId,
  onClose,
  rentSuccess,
  setSelectCabId,
  selectCabId,
  smallCabHasFreeBox,
  largeCabHasFreeBox,
  parcelUserId,
  parcelUserName,
  searchUserType,
}) => {
  // 取餐码租用柜门
  const [renBoxLazy, { loading: rentLoading }] = updateFoodifoxData<{ boxNumber: string; openCode: number; orderId: number; cabSizeType: string; openBoxes: Box[] }>('/foxH5RentBox/rentBoxNoPhone');

  const smallCabNoFreeBox = useRef<boolean>(false);
  const largeCabNoFreeBox = useRef<boolean>(false);
  // 显示没有空闲柜门弹窗
  const [showNoFreeBoxModal, setShowNoFreeBoxModal] = useState<boolean>();
  const [showSmallCabNoFreeBoxModal, setShowSmallCabNoFreeBoxModal] = useState<boolean>(false);
  const [showLargeCabNoFreeBoxModal, setShowLargeCabNoFreeBoxModal] = useState<boolean>(false);

  useEffect(() => {
    setShowLoading(rentLoading);

    return () => {
      setShowLoading(false);
    };
  }, [rentLoading]);

  /**
   * 租用柜门
   */
  const openBox = (cabId: number) => {
    if (cabId == null) {
      return;
    }

    renBoxLazy({
      param: {
        cabId: getCabId32Str(cabId),
        driverId,
        platform,
        parcelUserId,
        parcelUserName,
        searchUserType,
      },
      onError() {
        if (cabId === smallCabId || !smallCabHasFreeBox) {
          smallCabNoFreeBox.current = true;
        }
        if (cabId === largeCabId || !largeCabHasFreeBox) {
          largeCabNoFreeBox.current = true;
        }
        // 大小柜都没有空闲柜门时，提示没有空闲柜门
        if (smallCabNoFreeBox.current && largeCabNoFreeBox.current) {
          setShowNoFreeBoxModal(true);
        }
        // 如果选择小柜没有空闲柜门时，弹出提示是否选择大柜子
        else if (cabId === smallCabId) {
          setShowSmallCabNoFreeBoxModal(true);
        }
        // 如果选择大柜没有空闲柜门时，弹出提示是否选择小柜子
        else if (cabId === largeCabId) {
          setShowLargeCabNoFreeBoxModal(true);
        }
      },
      onCompleted(rentData: any) {
        const { boxNumber, openCode, orderId, openBoxes } = rentData;
        rentSuccess(orderId, openCode, openBoxes);
        addSystemLog(cabId, '', platform + '', '骑手ID：' + driverId + '，租用柜门：' + boxNumber + '，取餐码：' + openCode);
      },
    });
  };

  return (
    <>
      {
        showNoFreeBoxModal && (
          <NoFreeBoxModal
            onClose={() => {
              setShowNoFreeBoxModal(false);
            }}
            isEnglish={isEnglish}
          />
        )
      }
      {
        // 弹出小柜子没有空闲柜门，是否要使用大柜子
        showSmallCabNoFreeBoxModal && (
          <SmallCabNoFreeBoxModal
            onClose={() => {
              setShowSmallCabNoFreeBoxModal(false);
            }}
            onConfirm={() => {
              setShowSmallCabNoFreeBoxModal(false);
              setSelectCabId(largeCabId);
              openBox(largeCabId);
            }}
            onQuit={() => onClose()}
          />
        )
      }
      {
        // 弹出大柜子没有空闲柜门，是否要使用小柜子
        showLargeCabNoFreeBoxModal && (
          <LargeCabNoFreeBoxModal
            onClose={() => {
              setShowLargeCabNoFreeBoxModal(false);
            }}
            onConfirm={() => {
              setShowLargeCabNoFreeBoxModal(false);
              setSelectCabId(smallCabId);
              openBox(smallCabId);
            }}
            onQuit={() => onClose()}
          />
        )
      }

      <Button
        disabled={!selectCabId}
        onClick={() => {
          if (selectCabId) {
            openBox(selectCabId);
          }
        }}
        style={{ width: 311, height: 60, borderRadius: 60, background: selectCabId ? '#00B595' : '#D0D0D0', marginLeft: 'auto', marginRight: 'auto', marginTop: 55 }}
      >
        {
          isEnglish ? (
            <SquadBoldText fontSize={18} color={'#FFFFFF'}>
              Open door
            </SquadBoldText>
          ) : (
            <PingFangSemiBoldText fontSize={18} color={'#FFFFFF'}>
              开门
            </PingFangSemiBoldText>
          )
        }
      </Button>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  setShowLoading: (isShow: boolean) => void;
  platform: number;
  driverId: number;
  smallCabId: number;
  largeCabId: number;
  onClose: () => void;
  rentSuccess: (orderId: number, openCode: number, openBoxes: Box[]) => void;
  selectCabId?: number;
  setSelectCabId: (cabId: number) => void;
  smallCabHasFreeBox: boolean;
  largeCabHasFreeBox: boolean;
  parcelUserId: number;
  parcelUserName: string;
  searchUserType: string;
}

export default OpenBtn;
